import PropTypes from 'prop-types';

const optionalTaskModel = {
  description: PropTypes.string,
  name: PropTypes.string,
  taskCode: PropTypes.string,
};

export default optionalTaskModel;
